import { get } from 'lodash/fp';
import { updateConfig } from '../../../../app-config/errorTracking';
import type { CurrentUserDto } from '../../../../types/UserDtos';
import api from '../../../api';
import { getLoginUrl } from '../User';

type Subscriber = (user: CurrentUserDto) => void;

const subscribers: Subscriber[] = [];
let currentUserPromise: Promise<CurrentUserDto>;

export function loadCurrentUser(redirectToLogin = true) {
    if (currentUserPromise) {
        return currentUserPromise;
    }

    let initialRequest = true;

    currentUserPromise = new Promise((resolve, reject) => {
        api.currentUser.get.createObservable().subscribe(
            currentUser => {
                updateConfig(currentUser);
                setCurrentUser(currentUser);
                if (initialRequest) {
                    initialRequest = false;
                    resolve(currentUser);
                    return;
                }
                subscribers.forEach(sub => sub(currentUser));
            },
            error => {
                if (initialRequest) {
                    initialRequest = false;
                    if (redirectToLogin && get('response.status', error) === 401) {
                        window.location.replace(getLoginUrl(window.location.href.replace(window.location.origin, '')));
                        return;
                    }
                    reject(error);
                }
            }
        );
    });

    return currentUserPromise;
}

export function subscribe(subscriber: Subscriber) {
    subscribers.push(subscriber);
    return function unsubscribe() {
        const index = subscribers.indexOf(subscriber);
        if (index === -1) {
            return;
        }
        subscribers.splice(index, 1);
    };
}

export function getCurrentUserId(): string {
    return window._currentUser.id;
}

export function getCurrentUser(): CurrentUserDto {
    return window._currentUser;
}

function setCurrentUser(currentUser: CurrentUserDto) {
    window._currentUser = currentUser;
}

export function isInExperiment(codeId: string): boolean {
    const currentUser = getCurrentUser();
    if (!currentUser.experiment) {
        return false;
    }

    return currentUser.experiment.codeId === codeId;
}

export function isInExperimentBranch(codeId: string, branch: 'EXPERIMENT' | 'CONTROL'): boolean {
    const currentUser = getCurrentUser();
    if (!currentUser.experiment) {
        return false;
    }

    return currentUser.experiment.codeId === codeId && currentUser.experiment.branch === branch;
}
